// extracted by mini-css-extract-plugin
export default {"accountSection":"o_TgvXSOBSvT50t5fmVg","user":"_7OmPXSFjTzMcgdYNNRy","name":"skdyFJlEZEXNLhSCBnJF"};